import authService from './authService';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

const lessonPlanService = {
    /**
     * Ottieni Lesson Plan Attivo
     * @param {string|number} courseId
     */
    async getActivePlan(courseId) {
        const response = await authService.authenticatedFetch(`${API_BASE_URL}/lesson-plan/course/${courseId}/active`);
        if (!response.ok) {
            throw new Error('Impossibile recuperare il lesson plan attivo');
        }
        return await response.json();
    },

    /**
     * Genera Nuovo Lesson Plan
     * @param {string|number} courseId
     * @param {Array<number>} lessonIds
     */
    async generatePlan(courseId, lessonIds) {
        const response = await authService.authenticatedFetch(`${API_BASE_URL}/lesson-plan/course/${courseId}/generate`, {
            method: 'POST',
            body: JSON.stringify({ lesson_ids: lessonIds }),
        });

        // Gestione errori specifici (409 conflict, 403 forbidden) gestita dal chiamante tramite status
        if (!response.ok) {
            const errorData = await response.json();
            const error = new Error(errorData.message || 'Errore durante la generazione del piano');
            error.status = response.status;
            error.data = errorData;
            throw error;
        }
        return await response.json();
    },

    /**
     * Completa Lezione (Dopo Quiz)
     * @param {string|number} lessonPlanId
     * @param {string|number} lessonId
     * @param {boolean} quizPassed
     * @param {number} quizScore
     */
    async completeLesson(lessonPlanId, lessonId, quizPassed, quizScore) {
        const response = await authService.authenticatedFetch(`${API_BASE_URL}/lesson-plan/${lessonPlanId}/lesson/${lessonId}/complete`, {
            method: 'POST',
            body: JSON.stringify({
                quiz_passed: quizPassed,
                quiz_score: quizScore
            }),
        });

        if (!response.ok) {
            const errorData = await response.json();
            const error = new Error(errorData.message || 'Errore completamento lezione');
            error.status = response.status;
            error.data = errorData;
            throw error;
        }
        return await response.json();
    },

    /**
     * Annulla Generazione Lesson Plan
     * @param {string|number} lessonPlanId
     */
    async cancelPlan(lessonPlanId) {
        const response = await authService.authenticatedFetch(`${API_BASE_URL}/lesson-plan/${lessonPlanId}/cancel`, {
            method: 'DELETE',
        });

        if (!response.ok) {
            const errorData = await response.json();
            const error = new Error(errorData.message || 'Errore durante l\'annullamento del piano');
            error.status = response.status;
            error.data = errorData;
            throw error;
        }
        return await response.json();
    },


    /**
     * Aggiorna Artefatto Lesson Plan
     * @param { string | number } lessonPlanId
     * @param { string } artefactType 'sintesi', 'mappa', 'flashcard', 'quiz'
     * @param { string | number } artefactId
     */
    async associateArtefact(lessonPlanId, artefactType, artefactId) {
        const response = await authService.authenticatedFetch(`${API_BASE_URL}/lesson-plan/${lessonPlanId}/artefact`, {
            method: 'PUT',
            body: JSON.stringify({
                artefact_type: artefactType,
                artefact_id: artefactId
            }),
        });

        if (!response.ok) {
            throw new Error('Errore durante l\'associazione dell\'artefatto');
        }
        return await response.json();
    },

    /**
     * Ottieni Progresso Utente
     * @param {string|number} courseId
     */
    async getProgress(courseId) {
        const response = await authService.authenticatedFetch(`${API_BASE_URL}/lesson-plan/course/${courseId}/progress`);
        if (!response.ok) {
            throw new Error('Impossibile recuperare il progresso');
        }
        return await response.json();
    }
};

export default lessonPlanService;
